module.exports = __webpack_public_path__ + "img/PayPal.992bb68f.png";